import _defineProperty from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Slot as e } from "@radix-ui/react-slot";
import { useComposedRefs as r } from "@radix-ui/react-compose-refs";
import { createContextScope as t } from "@radix-ui/react-context";
import o from "react";
export function createCollection(c) {
  var n = c + "CollectionProvider",
      _t = t(n),
      _t2 = _slicedToArray(_t, 2),
      l = _t2[0],
      i = _t2[1],
      _l = l(n, {
    collectionRef: {
      current: null
    },
    itemMap: new Map()
  }),
      _l2 = _slicedToArray(_l, 2),
      f = _l2[0],
      a = _l2[1],
      u = function u(e) {
    var r = e.scope,
        t = e.children,
        c = o.useRef(null),
        n = o.useRef(new Map()).current;
    /*#__PURE__*/

    return o.createElement(f, {
      scope: r,
      itemMap: n,
      collectionRef: c
    }, t);
  },
      m = c + "CollectionSlot",
      s = /*#__PURE__*/o.forwardRef(function (t, c) {
    var n = t.scope,
        l = t.children,
        i = a(m, n),
        f = r(c, i.collectionRef);
    /*#__PURE__*/

    return o.createElement(e, {
      ref: f
    }, l);
  }),
      p = c + "CollectionItemSlot",
      d = "data-radix-collection-item",
      R = /*#__PURE__*/o.forwardRef(function (t, c) {
    var _o$createElement;

    var n = t.scope,
        l = t.children,
        i = _objectWithoutProperties(t, ["scope", "children"]),
        f = o.useRef(null),
        u = r(c, f),
        m = a(p, n);

    return o.useEffect(function () {
      return m.itemMap.set(f, _objectSpread({
        ref: f
      }, i)), function () {
        m.itemMap.delete(f);
      };
    }), /*#__PURE__*/o.createElement(e, (_o$createElement = {}, _defineProperty(_o$createElement, d, ""), _defineProperty(_o$createElement, "ref", u), _o$createElement), l);
  });

  return [{
    Provider: u,
    Slot: s,
    ItemSlot: R
  }, function (e) {
    var r = a(c + "CollectionConsumer", e);
    return o.useCallback(function () {
      var e = r.collectionRef.current;
      if (!e) return [];
      var t = Array.from(e.querySelectorAll("[".concat(d, "]")));
      return Array.from(r.itemMap.values()).sort(function (e, r) {
        return t.indexOf(e.ref.current) - t.indexOf(r.ref.current);
      });
    }, [r.collectionRef, r.itemMap]);
  }, i];
}